import {
  ADD_CAMPAIGN_MUTATION_KEY,
  IAddCampaignResponse,
  addCampaign,
} from '@/modules/study-insights/services/campaign/campaign';
import { ContextOptions, MutationFunction, UseMutationResult, useMutation } from '@tanstack/react-query';
import { AddCampaignFormStringValues } from '../../AddCampaignForm/AddCampaignForm.types';

interface IUseAddCampaign {
  onSuccess?: () => void;
  onError?: (err: any) => void;
}

export const useAddCampaign = ({
  onError,
  onSuccess,
}: IUseAddCampaign): UseMutationResult<IAddCampaignResponse, unknown, AddCampaignFormStringValues, ContextOptions> => {
  const mutationFn: MutationFunction<IAddCampaignResponse, AddCampaignFormStringValues> = async (
    campaignValues: AddCampaignFormStringValues,
  ): Promise<IAddCampaignResponse> => {
    return await addCampaign(campaignValues);
  };

  return useMutation<IAddCampaignResponse, unknown, AddCampaignFormStringValues, ContextOptions>(
    [ADD_CAMPAIGN_MUTATION_KEY],
    mutationFn,
    {
      onSuccess,
      onError,
    },
  );
};
